import axios from "axios";
import Storage from "./storage.js";
import router from "../router";
import iView from "view-design";
import _this from "../main";
import SparkMD5 from "spark-md5";
import JSEncrypt from "jsencrypt";

/* 请求拦截器 */
axios.interceptors.request.use(
  (config) => {
    // var root = process.env.VUE_APP_API_URL;
    // config.url = root + config.url;
    config.withCredentials = true;
    let trip = sessionStorage.getItem("trip");
    if (trip) {
      var encryptStr = new JSEncrypt();
      encryptStr.setPublicKey(trip); //设置加密公钥
      const randomNum = Math.floor(10000000 + Math.random() * 90000000);
      const cnSign = randomNum + "zwjt8081!@#DF*F&^SKD" + new Date().getTime();
      const encryptCnSign = encryptStr.encrypt(cnSign); //进行加密
      config.headers["cn-sign"] = encryptCnSign;
    }
    let token = window.sessionStorage.getItem("token");
    if (token) {
      config.headers.common["token"] = token;
      let ip = sessionStorage.getItem("webIp");
      let timestamp = new Date().getTime();
      let nonce = ip + "-" + timestamp;

      let sign = token + nonce;
      let spark = new SparkMD5();
      spark.append(sign);
      let signMd5 = spark.end();
      config.headers["zw-nonce"] = nonce;
      config.headers["zw-sign"] = signMd5;
    }
    return config;
  },
  function(error) {
    return new Promise.reject(error);
  }
);

/* 响应拦截器 */
axios.interceptors.response.use(
  function(response) {
    iView.LoadingBar.finish();
    var gitlist_ha = window.sessionStorage.getItem("gitlist_ha");
    // if () {
    //     iView.Message.warning("登录超时!");
    //     Storage.sessionRemove('token')
    //     setTimeout(function () {
    //         sessionStorage.clear()
    //         window.location.href = window.location.protocol + '//' + window.location.host + '/' + window.location.search
    //     }, 3000)
    //     return;
    // }

    if (
      response.data.resultCode === 10010 ||
      response.data.resultCode === 10011 ||
      response.data.resultCode == 1001 ||
      response.data.resultCode == 1003 ||
      response.data.resultCode == 1009
    ) {
      let u = navigator.userAgent;
      let isAndroid = u.indexOf("Android") > -1 || u.indexOf("Linux") > -1; //安卓
      let isIOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); //ios终端
      if (gitlist_ha) {
        iView.Message.warning("登录超时!");
        if (isAndroid) {
          window.android.tokenExpired();
          return;
        } else if (isIOS) {
          window.webkit.messageHandlers.tokenExpired.postMessage("null"); //ios
          return;
        }
      } else {
        iView.Message.warning("登录超时，请重新登录");
        if (isAndroid) {
          window.android.tokenExpired();
          return;
        } else if (isIOS) {
          window.webkit.messageHandlers.tokenExpired.postMessage("null"); //ios
          return;
        }
        Storage.sessionRemove("token");
        setTimeout(function() {
          sessionStorage.clear();
          window.location.href =
            window.location.protocol +
            "//" +
            window.location.host +
            "/" +
            window.location.search;
          if (response.data.resultCode == 1009) {
            sessionStorage.setItem("liscity", true);
          }
        }, 3000);
        return;
      }
    } else if (!response.headers.authorization) {
      // 判断token是否存在，如果存在说明需要更新token
      //   router.replace({
      //     path: '/login' // 到登录页重新获取token
      // })
      // Storage.localSet('token', response.data.token) // 覆盖原来的token(默认一天刷新一次)
    }

    return response;
  },
  function(error) {
    iView.LoadingBar.finish();
    // if (error.response.status == 504) {
    //     iView.Message.warning("连接超时，请稍后再试");
    // } else if (error.response.status == 502) {

    //     iView.Message.warning("数据加载失败，请稍后再试");
    // } else if (error.response.status == 404) {
    //     router.replace({
    //         path: '/404'
    //     })

    // } else if (error.response.status == 500) {
    //     iView.Message.warning("服务器错误，请联系开发人员");
    //     // >>>>>>> 9e09d88a806f4cad089c8df3e583ec8b1c1eb3a8
    // } else if (error.response.status == 400) {
    //     iView.Message.warning("请求失败，请稍后再试");
    // } else if (error.response.status == 401) {
    //     iView.Message.warning("登录超时，请重新登录");
    //     Storage.sessionRemove('token')
    //     Storage.sessionRemove('menu-list')
    //     setTimeout(function () {
    //         location.href = location.pathname;
    //     }, 2000)
    // }
    // else {
    //     return Promise.reject(error)
    // }
  }
);
